import { render, staticRenderFns } from "./JinNangBuyOrSale.vue?vue&type=template&id=2245f852&scoped=true&"
import script from "./JinNangBuyOrSale.vue?vue&type=script&lang=js&"
export * from "./JinNangBuyOrSale.vue?vue&type=script&lang=js&"
import style0 from "./JinNangBuyOrSale.vue?vue&type=style&index=0&id=2245f852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245f852",
  null
  
)

export default component.exports